document.addEventListener('DOMContentLoaded', function () {
    var citySelector = document.getElementById('selectCity');
    var mobileCitySelector = document.getElementById('selectCity2');

    // Helper function to calculate expected delivery date based on working days
    function getExpectedDeliveryDate(daysToAdd) {
        var now = new Date();
        var gmtPlus3 = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Riyadh' }));
        var day = gmtPlus3.getDay(); // 0 is Sunday, 6 is Saturday
        var addedDays = 0;

        while (addedDays < daysToAdd) {
            day = (day + 1) % 7; // Move to the next day
            // Skip Fridays (Friday = 5)
            if (day !== 5) {
                addedDays++;
            }
        }

        // Return the calculated date in a readable format
        var deliveryDate = new Date(gmtPlus3);
        deliveryDate.setDate(gmtPlus3.getDate() + addedDays);
        return deliveryDate.toLocaleDateString('en-GB', {
            weekday: 'long', 
            day: 'numeric', 
            month: 'long'
        });
    }

    // Function to update the delivery message based on the selected city, variant, and current time
    function updateDeliveryMessage(city, variantId) {
        // Hide all delivery messages initially
        document.querySelectorAll('.noshow').forEach(function (msg) {
            msg.style.display = 'none';
        });

        var showEligibleText = document.querySelector(
            '.show-eligible-text-' + variantId
        );
        var variantInput = document.querySelector(
            '.variant-selection-to-show-' + variantId
        );

        if (variantInput) {
            // Get delivery type based on the selected city and variant
            var deliveryType = getDeliveryTypeForCity(
                city, 
                variantInput
            );
        
            // Render message based on the delivery type and city
            renderDeliveryMessage(showEligibleText, deliveryType, city);
        }
    }

    // Determine delivery type based on selected city and warehouse metafields
    function getDeliveryTypeForCity(city, variantInput) {
        // Mapping of city to metafield
        let cityMetafieldMap = {
            "Riyadh": ['data-strryd', 'data-wrhryd'],
            "Jeddah": ['data-strjed', 'data-wrhjed'],
            "Dammam": ['data-strdmm', 'data-wrhdmm'],
            "Al Khobar": ['data-strkhb', 'data-wrhkhb'],
            "Makkah": ['data-strmca', 'data-wrhmca'],
            "Rest of KSA": ['data-wrhrest']
        };

        let deliveryType = 'default'; // Default to Express Delivery (3-4 working days)

        if (cityMetafieldMap[city]) {
            let metafields = cityMetafieldMap[city];

            // Priority: 1 > 2 > 3E > 3 > 4E > 4
            let priority = {
                '1': 'sameday',
                '2': 'nextday',
                '3E': '3daysExact',
                '3': '3days',
                '4E': '4daysExact',
                '4': '4days'
            };

            for (const level of ['1', '2', '3E', '3', '4E', '4']) {
                if (metafields.some((metafield) => variantInput.getAttribute(metafield) === level)) {
                    deliveryType = priority[level];
                    break; // Stop as soon as the highest priority is found
                }
            }
        }

        return deliveryType;
    }

    // Function to render the appropriate delivery message
    function renderDeliveryMessage(element, deliveryType, city) {
        const now = new Date();
        const gmtPlus3 = new Date(now.toLocaleString('en-US', {
            timeZone: 'Asia/Riyadh'
        }));
        const currentHour = gmtPlus3.getHours();
        const cutoffHour = 13; // 1 PM cutoff for same-day/next-day delivery
        let nextDayDate;

        switch (deliveryType) {
            case 'sameday':
                if (currentHour < cutoffHour) {
                    const hoursLeft = cutoffHour - currentHour;
                    element.innerHTML = `
                        <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                            SAMEDAY DELIVERY
                        </span><br> 
                        Get it today if you order within 
                        <u><strong>${hoursLeft} hours</strong></u> in <b>${city}</b>`;
                } else {
                    nextDayDate = getExpectedDeliveryDate(1);
                    element.innerHTML = `
                        <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                            PRIORITY DELIVERY
                        </span><br> 
                        Get it by <u><strong>tomorrow ${nextDayDate}</strong></u> in <b>${city}</b>`;
                }
                break;

            case 'nextday':
                nextDayDate = getExpectedDeliveryDate(1);
                if (currentHour < cutoffHour) {
                    const hoursLeft = cutoffHour - currentHour;
                    element.innerHTML = `
                        <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                            PRIORITY DELIVERY
                        </span><br> 
                        Get it by <u><strong>tomorrow ${nextDayDate}</strong></u> 
                        if you order within 
                        <u><strong>${hoursLeft} hours</strong></u> in <b>${city}</b>`;
                } else {
                    const dayAfterTomorrowDate = getExpectedDeliveryDate(2); 
                    element.innerHTML = `
                        <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                            PRIORITY DELIVERY
                        </span><br> 
                        Get it by <u><strong>${dayAfterTomorrowDate}</strong></u> in <b>${city}</b>`;
                }
                break;

            case '3days':
                element.innerHTML = `
                    <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                        EXPRESS DELIVERY
                    </span><br> 
                    Delivery in <u><strong>3 working days</strong></u> in <b>${city}</b>`;
                break;

            case '3daysExact':
                element.innerHTML = `
                    <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                        EXPRESS DELIVERY
                    </span><br> 
                    Get it by <u><strong>${getExpectedDeliveryDate(3)}</strong></u> in <b>${city}</b>`;
                break;

            case '4days':
                element.innerHTML = `
                    <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                        EXPRESS DELIVERY
                    </span><br> 
                    Delivery in <u><strong>4 working days</strong></u> in <b>${city}</b>`;
                break;

            case '4daysExact':
                element.innerHTML = `
                    <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                        EXPRESS DELIVERY
                    </span><br> 
                    Get it by <u><strong>${getExpectedDeliveryDate(4)}</strong></u> in <b>${city}</b>`;
                break;

            default:
                element.innerHTML = `
                    <span style="color:white;background-color:#677789;padding:5px;font-size:12px!important">
                        EXPRESS DELIVERY
                    </span><br> 
                    Delivery in <u><strong>3 to 4 working days</strong></u> in <b>${city}</b>`;
                break;
        }

        element.style.display = 'block';
    }

    // On page load, show message for the selected variant
    var selectedVariant = document.querySelector('.product-form__input input[type=radio]:checked');
    if (selectedVariant) {
        var selectedVariantId = selectedVariant.getAttribute('data-variant-id');
        var selectedCity = citySelector.options[citySelector.selectedIndex].getAttribute('data-country');
        updateDeliveryMessage(selectedCity, selectedVariantId);
    }

    // Listen for variant selection
    document.querySelectorAll('.product-form__input input[type=radio]').forEach(function (radio) {
        radio.addEventListener('change', function () {
            var selectedVariantId = this.getAttribute('data-variant-id');
            var selectedCity = citySelector.options[citySelector.selectedIndex].getAttribute('data-country');
            updateDeliveryMessage(selectedCity, selectedVariantId);
        });
    });

    // Listen for city selection (desktop)
    citySelector.addEventListener('change', function () {
        var selectedCity = this.options[this.selectedIndex].getAttribute('data-country');
        var selectedVariantId = document.querySelector('.product-form__input input[type=radio]:checked').getAttribute('data-variant-id');
        updateDeliveryMessage(selectedCity, selectedVariantId);
    });

    // Listen for city selection (mobile)
    mobileCitySelector.addEventListener('change', function () {
        var selectedCity = this.options[this.selectedIndex].getAttribute('data-country');
        var selectedVariantId = document.querySelector('.product-form__input input[type=radio]:checked').getAttribute('data-variant-id');
        updateDeliveryMessage(selectedCity, selectedVariantId);
    });
});




